const NESTED = typeof Symbol === 'function' && Symbol.for
  ? Symbol.for('mui.nested')
  : '__THEME_NESTED__';

const PSEUDO_CLASSES = [
  'checked',
  'disabled',
  'error',
  'focused',
  'focusVisible',
  'required',
  'expanded',
  'selected',
];

/**
 * Material-UI drops style keys in production (`jss1`, `jss2`, ...).
 * Dark mode targets those keys, so production keeps the same names as local development.
 */
const generateStableClassName = () => {
  let ruleCounter = 0;

  const nextId = () => {
    ruleCounter += 1;
    return ruleCounter;
  };

  return (rule, styleSheet) => {
    const options = styleSheet.options || {};
    const { name, link, theme, classNamePrefix } = options;

    if (name && name.indexOf('Mui') === 0 && !link) {
      if (PSEUDO_CLASSES.indexOf(rule.key) !== -1) {
        return `Mui-${rule.key}`;
      }

      const prefix = `${name}-${rule.key}`;
      if (!theme || !theme[NESTED]) {
        return prefix;
      }

      return `${prefix}-${nextId()}`;
    }

    const suffix = `${rule.key}-${nextId()}`;
    if (classNamePrefix) {
      return `${classNamePrefix}-${suffix}`;
    }

    return suffix;
  };
};

export default generateStableClassName;
